module.exports = __webpack_public_path__ + "img/close-menu.7b0e264f.svg";